import styled from "styled-components";
import { Section, MainTitle, Paragraf } from "../Styled";

export const HeroSection = styled.div`
height: 100vh;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background: linear-gradient(
    132deg,
    rgb(0, 48, 143) 0%,
    rgb(1, 180, 180) 100%
  );
`

export const HeroInner = styled(Section)`
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-between;
@media screen and (max-width: 768px) {
   flex-direction: column;
   height: auto;
}
`
export const HeroLeft = styled.div`
width: 50%;
display: flex;
flex-direction: column;
row-gap: 10px;
 & ${MainTitle} {
    margin: 0;
    color: ${({ theme }) => theme.mainColors.hvid}
 }
 & ${Paragraf} {
    margin: 0;
    color: ${({ theme }) => theme.mainColors.hvid}
 }
 @media screen and (max-width: 768px) {
   width: 100%;
}
`

export const HeroImg = styled.img`
height: 320px;
width: 320px;
border-radius: 20px;
box-shadow: 0 15px 30px rgb(0 0 29 / 25%);
object-fit: cover;
@media screen and (max-width: 768px) {
   display: none;
}
`